import { ready } from '~/core'

import pickit from '~/utils/pickit'
import upload from '~/utils/upload'
import validate from '~/utils/validate'

//add date picker functionality
ready('datePicker', '.datePicker input', (input) => {
  pickit(input)
})

//add file upload functionality
ready('fileUpload', '.fileUpload input', (input) => {
  upload(input)
})

//add validation functionality
ready('validation', '.formValidate', (form) => {
  validate(form)
})
